<template>
  <div class="flex" data-testid="prospects-lists">
    <div v-if="prospectLists" class="w-[240px] pt-2 pr-4">
      <nav class="rounded-lg bg-surface p-3" :aria-label="t('ProspectsCatalog.myProspects')" data-testid="prospects-lists-nav">
        <p class="mb-2 px-2 txt-label-s-bold text-subtle uppercase">
          {{ t('ProspectsCatalog.myProspects') }}
        </p>
        <div class="space-y-1">
          <RouterLink
            v-for="item of prospectLists"
            :key="item.id"
            :to="{ name: 'prospectList', params: { listId: toPlainId(item.id) } }"
            class="block rounded-md px-2 py-2 txt-body-s-regular text-main transition-colors hover:bg-surface-elevation-2"
            :class="{ 'bg-surface-elevation-2 txt-body-s-bold': isActiveList(item.id) }"
            :data-testid="`prospects-list-link-${toPlainId(item.id)}`"
          >
            {{ item.title }}
          </RouterLink>
        </div>
      </nav>
      <div class="mt-3">
        <RouterLink
          :to="{ query: { modal: 'newProspectList' } }"
          class="btn-outline-neutral-xs mb-7 text-main"
          data-testid="prospects-create-list-link"
        >
          <SvgIcon :path="mdiPlusCircleOutline" :size="16" />
          <span>{{ t('ProspectsCatalog.createList') }}</span>
        </RouterLink>
      </div>
    </div>
    <RouterView
      :facet-items="props.facetItems"
      :me="props.me"
      :prospect-lists="props.prospectLists"
      @create-prospect-item="emit('createProspectItem', $event)"
      @delete-prospect-item="emit('deleteProspectItem', $event)"
      @refetch-prospect-lists="emit('refetchProspectLists')"
    />
    <NewProspectListModal
      v-if="route.query['modal'] == 'newProspectList'"
      :event="event"
      :me="props.me"
      @refetch-prospect-lists="emit('refetchProspectLists')"
    />
  </div>
</template>

<script setup lang="ts">
import { mdiPlusCircleOutline } from '@mdi/js'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import type { ProspectFacetItems } from '@/components/Prospects/prospectFacetItems'
import type { Event, MeQuery } from '@/gql/myomr'
import { toPlainId } from '@/helpers/globalIdHelper'

import type { ProspectList } from './types'
const { t } = useI18n()

const route = useRoute()

const props = defineProps<{
  facetItems: ProspectFacetItems
  me: NonNullable<MeQuery['me']>
  prospectLists: ProspectList[]
  slug: string
  event: Event
}>()

const isActiveList = (listId: string) => toPlainId(listId) === route.params.listId

const emit = defineEmits<{
  (e: 'createProspectItem', value: { prospectId: string; prospectListId: string }): void
  (e: 'deleteProspectItem', value: { prospectId: string; prospectListId: string }): void
  (e: 'refetchProspectLists'): void
}>()
</script>
